import { Component } from '@angular/core';
import {CmsBannerComponent, CmsService, SemanticPathService} from '@spartacus/core';
import { BannerComponent, CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-uig-banner',
    templateUrl: './uig-banner.component.html',
    styleUrls: ['./uig-banner.component.scss'],
    standalone: false
})
export class UigBannerComponent extends BannerComponent {

  constructor(protected component: CmsComponentData<CmsBannerComponent>, urlService: SemanticPathService, cmsService: CmsService) {
    super(component, urlService, cmsService);
  }
}
